// Vue component for the directory structure rendering
<template>
    <span class="dataset">
        <div v-if="!isRoot" class="pretext">
            <span class="collapsible" @click="expand()" v-if="permission && (!loaded || root.datasets.length || root.distributions.length || root.groups.length)">
                <i v-if="root.isExpanded" class="far fa-minus-square" />
                <i v-else class="far fa-plus-square" />
            </span>
            <i v-else class="far fa-square" />
        </div>
        <div class="text">
            <i v-if="!isRoot" class="fa fa-database" />
            <a @click="clickName()">{{ root.dsName }}</a>
        </div>

        <span v-if="root.isExpanded">
            <span v-if="loaded">
                <sub-tree :root="root" @selectCrumbs="selectCrumbs" />
            </span>
            <Loading loading-message="" v-else />
        </span>
    </span>
</template>

<script>
import SubTree from 'src/components/dataset/components/SubTree.vue'
import Loading from 'src/components/Loading.vue'
import fetchUtils from 'src/components/dataset/fetchUtils.js'

export default {
    name: "DatasetTree",
    components: {
        SubTree,
        Loading
    },
    mixins: [fetchUtils],
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            default: "-"
        },
        permission: {
            type: Boolean,
            default: true
        },
        isRoot: {
            type: Boolean,
            default: false
        },
        givenRoot: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            root: { isExpanded: false, dsName: this.name },
            loaded: false,
            loading: false
        }
    },
    created: async function () {
        // if parent component already loaded dataset
        if (this.givenRoot) {
            this.root = this.givenRoot
            this.loaded = true
        }

        if (this.isRoot) {
            this.expand()
        }
    },
    methods: {
        clickName: async function() {
            await this.expand()

            if (this.permission) {
                this.selectCrumbs([this.root])
            } else {
                this.selectCrumbs([])
            }
        },
        selectCrumbs: function(crumbs=[]) {
            this.$emit("selectCrumbs", crumbs)
        },
        expand: async function() {
            if (!this.permission) return

            // toggle expansion for non-root datasets
            if (!this.isRoot) {
                this.root.isExpanded = !this.root.isExpanded
            } else {
                this.root.isExpanded = true
            }

            // load subtree if not already loading
            if (!this.loaded && !this.loading) {
                this.loading = this.load()
            }

            // wait to finish loading
            if (!this.loaded) {
                await this.loading
                this.root.isExpanded = true // always expand after loading
            }
        },
        load: async function() {
            this.root = await this.fetchDataset(this.id)
            this.loaded = true
        },
        
    }
}
</script>

<style scoped>
.dataset {
    overflow: hidden;
}

li::before {
    float: left;
}

.pretext {
    float: left;
    margin-right: 3.5px;
}

.pretext i {
    z-index: 1;
    position: relative;
    background-color: white;
    box-shadow: 0 -10px white;
}

.text {
    overflow: hidden;
    z-index: 1;
    position: relative;
    background-color: white;
    box-shadow: 0 -15px white;
}

a {
    cursor: pointer;
}
</style>
